import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import StationInvoicesContainer from '../../containers/accounting/StationInvoices';
import Transition from './Transition';

const styles = () => ({
	dialogPaper: {
		width: '80%',
	},
	row : {
		paddingBottom : 10,
	},
	label : {
		marginRight : 10,
	},
	value : {
		fontWeight : 600,
	},
	current : {

	},
	new : {
		marginTop : 20,
	},
	section : {
		margin : '30px 0px 10px 0px',
		textAlign : 'left',
	},
	sectionHeader : {
		textTransform : 'uppercase',
		fontSize : 14,
		color : '#777',
		fontWeight : 900,
		letterSpacing : 2,
	},
});

class ViewStationInvoiceLogDialog extends Component {
	constructor (props) {
		super(props);
		this.state = {};
	}

	componentDidUpdate(prevProps) {

		const { open, stationInvoice, stationInvoiceLogs, searchStationInvoiceLogs } = this.props;

		if (
			open
			&& prevProps.open !== open
			&& stationInvoice
			&& _.isEmpty(stationInvoiceLogs)
		) {
			const { stationInvoiceId } = stationInvoice;
			searchStationInvoiceLogs({
				stationInvoiceId
			});
		}
	}

	handleClose = () => {
		this.props.onClose();
	};

	render() {
		const {
			classes,
			stationInvoice,
			stationInvoiceLogs,
		} = this.props;

		if (!stationInvoice || !stationInvoiceLogs) { return null; }

		const logs = stationInvoiceLogs.map(r => {
			r.dateCreatedFormatted = moment(r.dateCreated).format('M/D h:mm a');
			return r;
		});

		const { stationInvoiceId } = stationInvoice;

		return (
			<div>
				<Dialog
					classes={{paper : classes.dialogPaper}}
					maxWidth='md'
					open={this.props.open}
					TransitionComponent={Transition}
					onClose={this.handleClose}
				>
					<DialogTitle>
						Station Invoice Id {stationInvoiceId}
					</DialogTitle>
					<DialogContent>
						<div className={classes.section}>
							<div className={classes.sectionHeader}>Logs</div>
						</div>
						{logs.map((log, i) => {
							return (
								<div key={i} className={classes.row}>
									<span className={classes.label}>
										<strong>{log.dateCreatedFormatted}</strong> - {log.entry}
									</span>
								</div>
							);
						})}

					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleClose}>
							Close
						</Button>
					</DialogActions>
				</Dialog>
			</div>
		);
	}
}

ViewStationInvoiceLogDialog.propTypes = {
	open : PropTypes.bool,
	onClose : PropTypes.func.isRequired,

	stationInvoice : PropTypes.object,
	searchStationInvoiceLogs : PropTypes.func.isRequired,
	stationInvoiceLogs : PropTypes.array,

	history : PropTypes.object,
	classes: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles),
	StationInvoicesContainer,
])(ViewStationInvoiceLogDialog);